// @flow

import React from 'react';
import type { Node } from 'react';
import type { FieldProps } from '../../../../types';
import LabeledSelect from './labeledSelect';
import { ReduxFormSelect } from '../../select';

type Props = {|
  ...FieldProps,
  label: string,
  children: Node,
  custom: any,
|};

export default ({ label, ...rest }: Props) => (
  <LabeledSelect label={label}>
    <ReduxFormSelect {...rest} label={label} />
  </LabeledSelect>
);
